import defaultApi from '@/utils/request';

export default {
  // S32W1004 -- 修課學生名單查詢
  TakeLesson_List(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1004_TakeLesson_List',
      params,
    });
  },
  // 加載列表
  Get_UnitId(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1004_Get_UnitId',
      params,
    });
  },
  Get_ClsId(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1004_Get_ClsId',
      params,
    });
  },
  Get_SubjectId(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1004_Get_SubjectId',
      params,
    });
  },

  // ========================================================================================================
  // S32W1003 開課一覽表
  Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1003_Get_YmsList',
      params,
    });
  },
  Get_DvsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1003_Get_DvsList',
      params,
    });
  },
  Get_DgreeList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1003_Get_DgreeList',
      params,
    });
  },
  Get_UnitList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1003_Get_UnitList',
      params,
    });
  },
  Get_ClsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1003_Get_ClsList',
      params,
    });
  },
  OpenLesson_List(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1003_Get_OpenLesson_List',
      params,
    });
  },

  // ========================================================================================================
  // S32W1001 課表與班級資料查詢
  S32W1001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1001_Load',
      params,
    });
  },
  S32W1001_GetPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1001_GetPDF',
      responseType: 'blob',
      params,
    });
  },
  // ========================================================================================================
  // S32W1002 老師開課一覽表
  S32W1002_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1002_Get_YmsList',
      params,
    });
  },
  S32W1002_Get_OpenLesson_List(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1002_Get_OpenLesson_List',
      params,
    });
  },
  S32W1002_Get_StuList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1002_Get_StuList',
      params,
    });
  },
  S32W1002_Get_PrtPDF_StuList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1002_Get_PrtPDF_StuList',
      responseType: 'blob',
      params,
    });
  },
  S32W1002_Get_PrtEXCEL_StuList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1002_Get_PrtEXCEL_StuList',
      responseType: 'blob',
      params,
    });
  },
  // ========================================================================================================
  // S32W1005 全部課程查詢Curriculum
  S32W1005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_Load',
      params,
    });
  },
  S32W1005_GetPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetPDF',
      responseType: 'blob',
      params,
    });
  },
  S32W1005_GetPDFUrl(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetPDFUrl',
      params,
    });
  },
  S32W1005_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_Query',
      params,
    });
  },
  GetStdList(params) {
    // 預設帶出學生所屬學制sch、院col、系unt
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetStdList',
      params,
    });
  },
  GetYmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetYmsList',
      params,
    });
  },
  GetColList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetColList',
      params,
    });
  },
  GetSchList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetSchList',
      params,
    });
  },
  GetPerList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetPerList',
      params,
    });
  },
  GetUntList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1005_GetUntList',
      params,
    });
  },
  // ========================================================================================================
  // S32W1006 教師課表查詢
  // 取得學年學期
  S32W1006_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1006_Get_YmsList',
      params,
    });
  },
  // 取得系科
  S32W1006_Get_UnitList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1006_Get_UnitList',
      params,
    });
  },
  S32W1006_Get_TeacherList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1006_Get_TeacherList',
      params,
    });
  },
  S32W1006_Get_ClassSchedule(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1006_Get_ClassSchedule',
      params,
    });
  },
  S32W1006_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1006_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },
  S32W1006_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1006_Query',
      params,
    });
  },
  // ========================================================================================================
  // S32W1007 學生課表查詢
  // 取得學年學期
  S32W1007_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1007_Get_YmsList',
      params,
    });
  },

  S32W1007_Get_StuList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1007_Get_StuList',
      params,
    });
  },
  S32W1007_Get_ClassSchedule(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1007_Get_ClassSchedule',
      params,
    });
  },
  S32W1007_Get_PersonalList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1007_GetPersonalList',
      params,
    });
  },
  // 列印
  S32W1007_Get_PrtPDF_Main(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1007_Get_PrtPDF_Main',
      responseType: 'blob',
      params,
    });
  },
  S32W1007_Get_PrtPDF_Detail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1007_Get_PrtPDF_Detail',
      responseType: 'blob',
      params,
    });
  },
  // ========================================================================================================
  // S32W1010 班級課表查詢
  // 取得學年學期
  S32W1010_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1010_Get_YmsList',
      params,
    });
  },
  S32W1010_Get_ClsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1010_Get_ClsList',
      params,
    });
  },
  // 取得系科
  S32W1010_Get_UnitList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1010_Get_UnitList',
      params,
    });
  },

  // 取得班級開課資訊
  S32W1010_Get_ClassSchedule(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1010_Get_ClassSchedule',
      params,
    });
  },

  S32W1010_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1010_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },
  // ========================================================================================================
  // S32W2003 課程棄修申請作業
  S32W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S32/S32W2003_Load',
      params,
    });
  },
  S32W2003_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S32/S32W2003_SaveApply',
      data,
    });
  },
  // ========================================================================================================
  // S32W4001 監考時間查詢
  // 取得班級開課資訊
  S32W4001_Get_InvigilationList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4001_Get_InvigilationList',
      params,
    });
  },
  // 取得學年學期
  S32W4001_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4001_Get_YmsList',
      params,
    });
  },
  // 列印
  S32W4001_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4001_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },
  // ========================================================================================================
  // S32W4002 歷年教學意見調查評量結果Annual Teaching Evaluation Results
  S32W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4002_Load',
      params,
    });
  },
  S32W4002_Layer2ViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4002_Layer2ViewLoad',
      params,
    });
  },
  S32W4002_StdFeedbackViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4002_StdFeedbackViewLoad',
      params,
    });
  },
  // ========================================================================================================
  // S32W4007 選課一覽表
  S32W4007_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4007_Load',
      params,
    });
  },
  S32W4007_GetCourseByClass(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4007_GetCourseByClass',
      params,
    });
  },
  S32W4007_GetCourseBySubject(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4007_GetCourseBySubject',
      params,
    });
  },
  // ========================================================================================================
  // S32W4003 調代補課查詢
  S32W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4003_Load',
      params,
    });
  },
  // 取得學年學期
  S32W4003_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4003_Get_YmsList',
      params,
    });
  },
  S32W4003_Get_UnitList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4003_Get_UnitList',
      params,
    });
  },

  // ========================================================================================================
  // S32W4005 暑修退費查詢
  // 取得暑修退費資料
  S32W4005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4005_Load',
      params,
    });
  },

  // ========================================================================================================
  // S32W4006 課表資料查詢
  // 取得學年學期
  S32W4006_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4006_Get_YmsList',
      params,
    });
  },
  S32W4006_Get_ClassSchedule(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4006_Get_ClassSchedule',
      params,
    });
  },
  S32W4006_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4006_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },
  // ========================================================================================================
  // S32W4008 學生英文選課一覽表 (Student Schedule)
  S32W4008_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4008_Load',
      params,
    });
  },

  // ========================================================================================================
  // S32W1008 教室課表查詢
  S32W1008_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1008_Get_YmsList',
      params,
    });
  },
  S32W1008_Get_RoomList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1008_Get_RoomList',
      params,
    });
  },
  S32W1008_Get_Data(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1008_Get_Data',
      params,
    });
  },
  S32W1008_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1008_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },

  // ========================================================================================================
  // S32W4004 代課費明細查詢
  S32W4004_Get_MainData(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4004_Get_MainDataForTableData',
      params,
    });
  },
  S32W4004_Get_DetailData(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4004_Get_DetailDataForTableData',
      params,
    });
  },
  S32W4004_Get_PrtPDF_Main(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4004_Get_PrtPDF_Main',
      responseType: 'blob',
      params,
    });
  },
  S32W4004_Get_PrtPDF_Detail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W4004_Get_PrtPDF_Detail',
      responseType: 'blob',
      params,
    });
  },

  // ========================================================================================================
  // S32W1009 教學綱要查詢
  S32W1009_Get_YmsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1009_Get_YmsList',
      params,
    });
  },
  S32W1009_Get_UnitList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1009_Get_UnitList',
      params,
    });
  },
  S32W1009_Get_DegreeList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1009_Get_DegreeList',
      params,
    });
  },
  S32W1009_Get_DivisionList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1009_Get_DivisionList',
      params,
    });
  },
  S32W1009_Get_MainData(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1009_Get_MainDataForTableData',
      params,
    });
  },
  S32W1009_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S32/S32W1009_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },
  // ================================ S32W2002 ==========================================
  S32W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S32/S32W2002_Load',
      params,
    });
  },
  S32W2002_LoadCourseList(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S32/S32W2002_LoadCourseList',
      params,
    });
  },
  S32W2002_LoadQuestion(params) {
    return defaultApi({
      method: 'get',
      url: 'S03/S32/S32W2002_LoadQuestion',
      params,
    });
  },
  S32W2002_SaveInputData(data) {
    return defaultApi({
      method: 'post',
      url: 'S03/S32/S32W2002_SaveInputData',
      data,
    });
  },
  // ====================================================================================
};
